export default "__VITE_ASSET__DMukwcLf__"